<template>
    <div v-if="article != null">
        <alert-message type="success" :message="successMessage" :timeout="5000"></alert-message>
        <alert-message type="danger" :errors="errors"></alert-message>
        <div v-for="(b, idx) in blocksSorted">
            <div class="row" v-show="showBlockControl(b)">
                <hr />
                <div class="span12">
                    <button type="button" class="btn btn-mini btn-danger" v-on:click.prevent="remove(idx)"><span class="icon-trash icon-white"></span></button>
                    <button type="button" class="btn btn-mini btn-primary" v-show="showUp(idx)" v-on:click.prevent="moveUp(idx)"><span class="icon-arrow-up icon-white"></span></button>
                    <button type="button" class="btn btn-mini btn-primary" v-show="showDown(idx)" v-on:click.prevent="moveDown(idx)"><span class="icon-arrow-down icon-white"></span></button>
                </div>
            </div>
            <block-text v-if="b.block == 0" label="Titulek" :index="idx" :text.sync="b.title"></block-text>
            <block-text v-if="b.block == 21" label="SEO Title" :index="idx" :text.sync="b.title"></block-text>
            <block-text v-if="b.block == 20" label="SEO Description" :index="idx" :text.sync="b.description"></block-text>
            <block-text v-if="b.block == 22" label="SEO Keywords" :index="idx" :text.sync="b.keywords"></block-text>
            <block-html v-if="b.block == 30" label="Blok textu" :index="idx" :html.sync="b.html"></block-html>
            <block-image v-if="b.block == 40" label="Obrázek" :index="idx" :image.sync="b.image"></block-image>
            <block-gallery v-if="b.block == 50" label="Galerie obrázků" :index="idx" :images.sync="b.images"></block-gallery>
            <block-html v-if="b.block == 60" label="Citát (černý)" :index="idx" :html.sync="b.html"></block-html>
            <block-html v-if="b.block == 61" label="Citát (šedý)" :index="idx" :html.sync="b.html"></block-html>
            <block-html v-if="b.block == 62" label="Citát (oranžový)" :index="idx" :html.sync="b.html"></block-html>

            <block-text v-if="b.block == 70" label="Osoba u reference" :index="idx" :text.sync="b.person"></block-text>
            <block-html v-if="b.block == 70" label="Popis reference" :index="idx" :html.sync="b.html"></block-html>
            <block-check v-if="b.block == 70" label="Viditelná" :index="idx" :val.sync="b.isVisible"></block-check>
            <block-gallery v-if="b.block == 70" label="Galerie u reference" :index="idx" :images.sync="b.images"></block-gallery>
            <block-attachment v-if="b.block == 70" label="Příloha u reference" :index="idx" :attachment.sync="b.attachment"></block-attachment>

            <block-text v-if="b.block == 80" label="Titulek" :index="idx" :text.sync="b.title"></block-text>
            <block-text v-if="b.block == 80" label="Podtitulek" :index="idx" :text.sync="b.subTitle"></block-text>
            <block-text v-if="b.block == 80" label="Magazín" :index="idx" :text.sync="b.magazine"></block-text>
            <block-text v-if="b.block == 80" label="Datum" :index="idx" :text.sync="b.date"></block-text>
            <block-html v-if="b.block == 80" label="Popis článku" :index="idx" :html.sync="b.html"></block-html>
            <block-gallery v-if="b.block == 80" label="Galerie u článku" :index="idx" :images.sync="b.images"></block-gallery>
            <block-attachment v-if="b.block == 80" label="Příloha u článku" :index="idx" :attachment.sync="b.attachment"></block-attachment>
        </div>
        <div class="form-group">
            <select class="m-t-20" v-model="newBlockId">
                <option :value="null" v-model="newBlockId">-- nový blok --</option>
                <option v-for="nb in newBlocks" :value="nb.id">{{ nb.name }}</option>
            </select>
        </div>
        <button class="btn btn-warning" v-on:click.prevent="addBlock" :disabled="newBlockId == null"><span class="glyphicon glyphicon-plus"></span> Přidat blok</button>
        <div class="form-group m-t-20">
            <button class="btn btn-success btn-large" :disable="working" @click.prevent="saveArticle">ULOŽIT</button>
        </div>
    </div>
</template>

<script>
    var axios = require('axios');
    import BlockText from './_block-text.vue'
    import BlockHtml from './_block-html.vue'
    import BlockImage from './_block-image.vue'
    import BlockGallery from './_block-gallery.vue'
    import BlockAttachment from './_block-attachment.vue'
    import BlockCheck from './_block-check.vue'
    import AlertMessage from './_alert-message.vue'

    export default {
        name: 'app',
        components: {
            BlockText,
            BlockHtml,
            BlockImage,
            BlockAttachment,
            AlertMessage,
            BlockGallery,
            BlockCheck
        },
        data() {
            return {
                article: __ARTICLE__,
                newBlocks: __NEWBLOCKS__,
                newBlockId: null,
                working: false,
                errors: [],
                successMessage: null
            }
        },
        created() {
            var self = this;
        },
        computed: {
            blocksSorted() {
                var self = this;
                return self.article.blocks.sort((a, b) => { return a.displayOrder - b.displayOrder });
            }
        },
        methods: {
            remove(idx) {
                var self = this;
                self.article.blocks.splice(idx, 1);
            },
            showUp(idx) {
                var self = this;

                if (idx == 0) {
                    return false;
                }

                var prev = self.article.blocks[idx - 1];

                if (!self.showBlockControl(prev)) {
                    return false;
                }

                return true;
            },
            showDown(idx) {
                var self = this;

                if (idx >= self.article.blocks.length - 1) {
                    return false;
                }

                var next = self.article.blocks[idx + 1];

                if (!self.showBlockControl(next)) {
                    return false;
                }

                return true;
            },
            moveUp(idx) {
                var self = this;
                var now = self.article.blocks[idx];
                var prev = self.article.blocks[idx - 1];
                var temp = prev.displayOrder;
                prev.displayOrder = now.displayOrder;
                now.displayOrder = temp;

                //self.article.blocks.splice(idx - 1, 2, now, prev);
            },
            moveDown(idx) {
                var self = this;
                var now = self.article.blocks[idx];
                var next = self.article.blocks[idx + 1];
                var temp = next.displayOrder;
                next.displayOrder = now.displayOrder;
                now.displayOrder = temp;

                //self.article.blocks.splice(idx, 2, next, now);
            },
            showBlockControl(b) {
                var self = this;
                return _.some(self.newBlocks, (x) => { return x.id == b.block });
            },
            addBlock() {
                var self = this;
                axios.get('/admin/getnewblock', {
                    params: {
                        blockId: self.newBlockId
                    }
                }).then(response => {
                    self.newBlockId = null;

                    var b = response.data.blocks[0];
                    var max = self.article.blocks.map((o) => { return o.displayOrder }).reduce((acc, cur) => Math.max(acc, cur));
                    b.displayOrder = max + 1;
                    self.article.blocks.push(b);
                })
                    .catch(error => {
                        self.newBlockId = null;
                    });
            },
            saveArticle() {
                var self = this;

                if (self.working) {
                    return;
                }

                self.working = true;
                self.errors = [];
                self.successMessage = null;

                axios.post('/admin/article2', {
                    cms: self.article
                }).then(response => {
                    self.newBlockId = null;
                    self.article = response.data;
                    self.working = false;
                    self.successMessage = 'Článek byl uložen.';
                    window.scrollTo(0, 0);
                })
                    .catch(error => {
                        self.errors = error.response.data;
                        self.working = false;
                    });
            }
        }
    }
</script>

<style>
    .m-t-20 {
        margin-top: 20px;
    }
</style>


// WEBPACK FOOTER //
// admin-article.vue?7f715140